(() => {
  function moneyFormat(cents) {
    const rawFormat = window.dfLooksPageMoneyFormat || "LE {{amount}}";
    const amount = (Number(cents || 0) / 100).toFixed(2);
    return rawFormat.replace(/\{\{\s*amount\s*\}\}/g, amount);
  }

  async function addToCart(variantId) {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }]
      })
    });

    if (!response.ok) throw new Error("Add to cart failed");

    if (typeof window.dfSyncCartIconBubble === "function") {
      await window.dfSyncCartIconBubble();
    }

    if (typeof window.openDeframeCart === "function") {
      window.openDeframeCart();
    }
  }

  async function addMultipleToCart(variantIds) {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify({
        items: variantIds.map((id) => ({
          id: Number(id),
          quantity: 1
        }))
      })
    });

    if (!response.ok) throw new Error("Add look failed");

    if (typeof window.dfSyncCartIconBubble === "function") {
      await window.dfSyncCartIconBubble();
    }

    if (typeof window.openDeframeCart === "function") {
      window.openDeframeCart();
    }
  }

  function normalizeProduct(product) {
    if (!product) return null;

    const variants = Array.isArray(product.variants) ? product.variants : [];
    const hasRealVariants = variants.some((v) => v.title !== "Default Title");

    return {
      ...product,
      hasRealVariants,
      firstAvailableVariant: variants.find((v) => v.available) || variants[0] || null
    };
  }

  function initLooksPage(section) {
    if (section.dataset.looksReady === "true") return;
    section.dataset.looksReady = "true";

    const looks = Array.from(section.querySelectorAll(".df-looks__card"));
    const overlay = section.querySelector("[data-looks-overlay]");
    const drawer = section.querySelector("[data-looks-drawer]");
    const sheet = section.querySelector("[data-looks-sheet]");

    const panelProducts = section.querySelector("[data-panel-products]");
    const sheetProducts = section.querySelector("[data-sheet-products]");

    const panelAddLook = section.querySelector("[data-panel-add-look]");
    const sheetAddLook = section.querySelector("[data-sheet-add-look]");

    const panelLabel = section.querySelector("[data-panel-look-label]");
    const panelCount = section.querySelector("[data-panel-look-count]");
    const panelTotal = section.querySelector("[data-panel-look-total]");

    const sheetLabel = section.querySelector("[data-sheet-look-label]");
    const sheetCount = section.querySelector("[data-sheet-look-count]");
    const sheetTotal = section.querySelector("[data-sheet-look-total]");

    let selectedVariants = [];

    const looksData = looks.map((look) => {
      const dataTag = look.querySelector(".df-looks__data");
      const parsed = JSON.parse(dataTag?.textContent || "{}");

      return {
        label: parsed.label || "",
        productCount: Number(parsed.productCount || 0),
        totalPrice: Number(parsed.totalPrice || 0),
        products: (parsed.products || []).map(normalizeProduct).filter(Boolean)
      };
    });

    function isMobile() {
      return window.matchMedia("(max-width: 749px)").matches;
    }

    function resetAddLookButtons() {
      selectedVariants = [];

      [panelAddLook, sheetAddLook].forEach((button) => {
        if (!button) return;
        button.disabled = true;
        button.innerHTML = `<span class="df-looks__add-look-left">SELECT ALL SIZES</span>`;
      });
    }

    function closeAllPanels() {
      if (overlay) overlay.hidden = true;

      drawer?.classList.remove("is-open");
      drawer?.setAttribute("aria-hidden", "true");

      sheet?.classList.remove("is-open");
      sheet?.setAttribute("aria-hidden", "true");

      document.documentElement.classList.remove("df-looks-lock");
      document.body.classList.remove("df-looks-lock");

      resetAddLookButtons();
    }

    function getAddLookButtonForContainer(container) {
      if (container === panelProducts) return panelAddLook;
      if (container === sheetProducts) return sheetAddLook;
      return null;
    }

    function updateAddLookState(container, look) {
      const button = getAddLookButtonForContainer(container);
      if (!button || !look) return;

      const items = Array.from(container.querySelectorAll(".df-looks-product"));
      const ids = items.map((item) => item.dataset.selectedVariantId).filter(Boolean);

      selectedVariants = ids;

      const allSelected = ids.length === items.length && items.length > 0;

      button.disabled = !allSelected;
      button.innerHTML = allSelected
        ? `<span class="df-looks__add-look-left">ADD LOOK</span><span class="df-looks__add-look-right">${moneyFormat(look.totalPrice)}</span>`
        : `<span class="df-looks__add-look-left">SELECT ALL SIZES</span>`;
    }

    function renderProducts(container, look) {
      if (!container || !look) return;

      container.innerHTML = "";
      resetAddLookButtons();

      look.products.forEach((product) => {
        const item = document.createElement("div");
        item.className = "df-looks-product";

        let badgeHTML = "";

        if (!product.available) {
          badgeHTML = '<span class="df-badge df-badge--soldout">Sold out</span>';
        } else if (product.isOnSale) {
          badgeHTML = '<span class="df-badge df-badge--sale">Sale</span>';
        }

        const gallery = document.createElement("div");
        gallery.className = "df-looks-product__gallery";

        const imageList =
          Array.isArray(product.images) && product.images.length
            ? product.images
            : [product.featuredImage].filter(Boolean);

        imageList.forEach((src) => {
          const image = document.createElement("img");
          image.className = "df-looks-product__image";
          image.src = src;
          image.alt = product.title || "";
          image.draggable = false;
          gallery.appendChild(image);
        });

        const title = document.createElement("div");
        title.className = "df-looks-product__title";
        title.textContent = product.title || "";

        const price = document.createElement("div");
        price.className = "df-looks-product__price";

        if (product.isOnSale && product.compareAtPrice) {
          price.innerHTML =
            '<span class="df-price--compare">' +
            moneyFormat(product.compareAtPrice) +
            '</span> ' +
            '<span class="df-price--sale">' +
            moneyFormat(product.price) +
            '</span>';
        } else {
          price.textContent = moneyFormat(product.price);
        }

        const label = document.createElement("div");
        label.className = "df-looks-product__label";
        label.textContent = "SELECT SIZE";

        const sizes = document.createElement("div");
        sizes.className = "df-looks-product__sizes";

        const variants = Array.isArray(product.variants) ? product.variants : [];
        const hasAvailable = variants.some((variant) => variant.available);

        const add = document.createElement("button");
        add.type = "button";
        add.className = "df-looks-product__add";
        add.disabled = true;

        if (!hasAvailable) {
          add.classList.add("is-sold-out");
          add.textContent = "SOLD OUT";
        } else {
          add.textContent = "SELECT SIZE";
        }

        let selectedVariantId = null;

        if (product.hasRealVariants) {
          variants.forEach((variant) => {
            const btn = document.createElement("button");
            btn.type = "button";
            btn.className = "df-looks-product__size";
            btn.dataset.variantId = variant.id;
            btn.textContent = variant.option1 || variant.title;

            if (!variant.available) {
              btn.classList.add("is-unavailable");
            }

            btn.addEventListener("click", () => {
              if (!variant.available) return;

              sizes.querySelectorAll(".df-looks-product__size").forEach((el) => {
                el.classList.remove("is-active");
                el.classList.remove("is-selected");
              });

              btn.classList.add("is-active");
              btn.classList.add("is-selected");

              selectedVariantId = variant.id;
              item.dataset.selectedVariantId = variant.id;

              add.disabled = false;
              add.classList.remove("is-sold-out");
              add.textContent = "ADD";

              updateAddLookState(container, look);
            });

            sizes.appendChild(btn);
          });
        } else if (product.firstAvailableVariant) {
          selectedVariantId = product.firstAvailableVariant.id;

          if (product.firstAvailableVariant.available) {
            item.dataset.selectedVariantId = product.firstAvailableVariant.id;
            add.disabled = false;
            add.textContent = "ADD";
          } else {
            add.disabled = true;
            add.classList.add("is-sold-out");
            add.textContent = "SOLD OUT";
          }
        }

        add.addEventListener("click", async () => {
          if (add.classList.contains("is-sold-out")) return;
          if (!selectedVariantId) return;

          const matchedVariant = variants.find((v) => String(v.id) === String(selectedVariantId));

          if (matchedVariant && !matchedVariant.available) {
            add.classList.add("is-sold-out");
            add.disabled = true;
            add.textContent = "SOLD OUT";
            return;
          }

          add.disabled = true;
          add.textContent = "ADDING";

          try {
            await addToCart(selectedVariantId);
            closeAllPanels();
          } catch (e) {
            console.error(e);
            add.disabled = false;
            add.textContent = "ADD";
          }
        });

        if (badgeHTML) {
          const badgeWrapper = document.createElement("div");
          badgeWrapper.innerHTML = badgeHTML;
          item.appendChild(badgeWrapper.firstChild);
        }

        item.appendChild(gallery);
        item.appendChild(title);
        item.appendChild(price);
        item.appendChild(label);
        item.appendChild(sizes);
        item.appendChild(add);

        container.appendChild(item);
      });

      updateAddLookState(container, look);
    }

    function openLook(index) {
      const look = looksData[index];
      if (!look) return;

      if (overlay) overlay.hidden = false;

      document.documentElement.classList.add("df-looks-lock");
      document.body.classList.add("df-looks-lock");

      if (isMobile()) {
        if (sheetLabel) sheetLabel.textContent = look.label;
        if (sheetCount) sheetCount.textContent = look.productCount + " PRODUCT" + (look.productCount === 1 ? "" : "S");
        if (sheetTotal) sheetTotal.textContent = "TOTAL PRICE: " + moneyFormat(look.totalPrice);

        renderProducts(sheetProducts, look);

        sheet?.classList.add("is-open");
        sheet?.setAttribute("aria-hidden", "false");
      } else {
        if (panelLabel) panelLabel.textContent = look.label;
        if (panelCount) panelCount.textContent = look.productCount + " PRODUCT" + (look.productCount === 1 ? "" : "S");
        if (panelTotal) panelTotal.textContent = "TOTAL PRICE: " + moneyFormat(look.totalPrice);

        renderProducts(panelProducts, look);

        drawer?.classList.add("is-open");
        drawer?.setAttribute("aria-hidden", "false");
      }
    }

    looks.forEach((look, index) => {
      look.addEventListener("click", () => openLook(index));
      look.addEventListener("keydown", (event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          openLook(index);
        }
      });
    });

    section.querySelector("[data-close-drawer]")?.addEventListener("click", closeAllPanels);
    section.querySelector("[data-close-sheet]")?.addEventListener("click", closeAllPanels);
    overlay?.addEventListener("click", closeAllPanels);

    [panelAddLook, sheetAddLook].forEach((button) => {
      button?.addEventListener("click", async () => {
        if (!selectedVariants.length) return;

        button.disabled = true;
        button.textContent = "ADDING";

        try {
          await addMultipleToCart(selectedVariants);
          closeAllPanels();
        } catch (e) {
          console.error(e);
          button.disabled = false;
          button.textContent = "ADD LOOK";
        }
      });
    });
  }

  function initAll() {
    document.querySelectorAll(".df-looks").forEach(initLooksPage);
  }

  document.addEventListener("DOMContentLoaded", initAll);
  document.addEventListener("shopify:section:load", initAll);
})();
